<template>
  <div class="home">
    <!-- Banner区域 -->
    <HeroSection :info="defaultInfos" />
    <!-- 介绍区域 -->
    <IntroSection :info="defaultInfos" />
    <!-- 服务区域 -->
    <ServicesSection :info="defaultInfos" :servicesinfo="featureServices" />
    <DepartmentsSection :departments="departments" :info="defaultInfos" />
    <DoctorsSection
      :info="mzDoctors"
      :tips="{
        title: defaultInfos.home_header3!,
        description: defaultInfos.home_header3_subtitle!,
      }"
    />
    <DoctorsSection
      :info="zyDoctors"
      :tips="{
        title: defaultInfos.home_header4!,
        description: defaultInfos.home_header4_subtitle!,
      }"
    />
    <NewsSection :news="news" :info="defaultInfos" />
  </div>
</template>

<script setup lang="ts">
import HeroSection from "./components/HeroSection.vue";
import IntroSection from "./components/IntroSection.vue";
import ServicesSection from "./components/ServicesSection.vue";
import DepartmentsSection from "./components/DepartmentsSection.vue";
import DoctorsSection from "./components/DoctorsSection.vue";
import NewsSection from "./components/NewsSection.vue";
import { useDoctorsListStore } from "@/stores/doctors";
import { useDepartmentsStore } from "@/stores/departments";
import { useDefaultInfoStore } from "@/stores/defaultInfo.ts";
import { useFeatureServiceStore } from "@/stores/featuredService.ts";
import { computed, onMounted } from "vue";
import { useNewsStore } from "@/stores/news";

const doctorsListStore = useDoctorsListStore();
const departmentsStore = useDepartmentsStore();
const newsStore = useNewsStore();
const defaultInfoStore = useDefaultInfoStore();
const featureServiceStore = useFeatureServiceStore();

// 直接使用计算属性，避免额外的 ref
const mzDoctors = computed(() => doctorsListStore.homeOutDoctors);
const zyDoctors = computed(() => doctorsListStore.homeInDoctors);
const departments = computed(() => departmentsStore.getHomeDepartments);
const featureServices = computed(() => featureServiceStore.featureServices);
const news = computed(() => newsStore.getNewsList.slice(0, 4));
const defaultInfos = computed(() => defaultInfoStore.getFormateInfo);

onMounted(async () => {
  await Promise.all([
    doctorsListStore.fetchDoctorsList(),
    departmentsStore.fetchDepartmentsList(),
    newsStore.fetchNewsList(),
    featureServiceStore.fetchFeatureServices(),
  ]);
});
</script>

<style scoped>
.home {
  width: 100%;
}
</style>
